const moduleMap = {
	"./OptimizerApp": () => {
		return Promise.all([__webpack_require__.e(3418), __webpack_require__.e(7382), __webpack_require__.e(9750), __webpack_require__.e(1881), __webpack_require__.e(4392), __webpack_require__.e(2995), __webpack_require__.e(9135), __webpack_require__.e(2092), __webpack_require__.e(6717), __webpack_require__.e(3329), __webpack_require__.e(3785), __webpack_require__.e(6273), __webpack_require__.e(6921), __webpack_require__.e(879), __webpack_require__.e(8403), __webpack_require__.e(9203), __webpack_require__.e(8029), __webpack_require__.e(5276), __webpack_require__.e(2068)]).then(() => (() => ((__webpack_require__(22068)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});